import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function StickyAlertBar() {
  return <motion.div initial={{
    y: -50
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5,
    ease: 'easeOut'
  }} className="sticky top-0 z-50 w-full bg-primary text-base py-2.5 px-4 text-center shadow-sm" data-id="element-187">
      <p className="text-xs md:text-sm font-medium tracking-wide flex items-center justify-center gap-2" data-id="element-188">
        <Clock className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-189" />
        <span data-id="element-190">OFERTA POR TIEMPO LIMITADO — 80% OFF — Cierra pronto</span>
      </p>
    </motion.div>;
}